import { render } from "./LineChartDemo.vue?vue&type=template&id=74a5f544&scoped=true"
import script from "./LineChartDemo.vue?vue&type=script&lang=ts"
export * from "./LineChartDemo.vue?vue&type=script&lang=ts"

import "./LineChartDemo.vue?vue&type=style&index=0&id=74a5f544&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74a5f544"

export default script